import { ReactElement } from 'react';
import { Typography, Pagination } from '@mui/material';
import { useTranslation } from 'react-i18next';

type PaginationProps = {
  totalNumber: number;
  totalPagesNumber: number;
  onMovePage: (page: number) => void;
  page: number;
};

export function PaginationWithTotal({ totalNumber, totalPagesNumber, onMovePage, page }: PaginationProps): ReactElement {
  const { t } = useTranslation();

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Typography data-testid={'projects-count'}>{t('projects-page.label-number-of-projects', { count: totalNumber })}</Typography>
      {totalPagesNumber > 1 && (
        <Pagination
          data-testid={'projects-pagination'}
          sx={{
            '& .MuiPaginationItem-previousNext': { color: '#004289' },
            '& .MuiPaginationItem-firstLast': { color: '#004289' },
            marginLeft: '40px',
          }}
          count={totalPagesNumber}
          showFirstButton
          showLastButton
          onChange={(event, value) => onMovePage(value)}
          page={page}
        />
      )}
    </div>
  );
}
